module.exports = {
	agree: 'Agree to',
	tos: 'Enhancer terms',
	privacy: 'Privacy',
	inviteCodeInvalid: 'invalid invitation code',
  inviteCode: "Invite code(optional)"
}


// WEBPACK FOOTER //
// ./src/pages/register/i18n/locale.en.js